import { Text } from "components";
import { screens } from "constants/enums";
import { toggleDrawer } from "pages/drawer/drawerSlice";
import React from "react";
import { Dropdown, Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import LogOutSvg from "../assets/icons/svg/logout";
import "./style.css";
import "./styles.scss";
import UserSettingsComponent from "assets/icons/svg/settingsUser";

import { useHistory } from "react-router-dom";
import { getAuthenticated, getLocalStorageItem } from "utils/functions";
import { Fonts, FontColors } from "theme/fontConfig";

const styles = {
  body: {
    zIndex: 1003,
    minHeight: 70,
  },
  imgBody: {
    borderRadius: "50%",
    background: "#B5B5C3",
    width: 49,
    height: 49,
    marginInlineEnd: 10,
    cursor: "pointer",
  },
  nameProfileText: {
    color: FontColors.Slate464E5F,
    fontWeight: Fonts.GeneralSmallHeaderFont.fontWeight,
    fontSize: Fonts.GeneralSmallHeaderFont.fontSize,
  },
  userNameContainer: {
    marginTop: -5,
  },
  userNameProfileText: {
    color: FontColors.Gray7B7B8B,
    fontSize: Fonts.GeneralBodyFont.fontSize,
    lineHeight: 1.2,
  },
  tagProfileText: {
    color: FontColors.Slate464E5F,
    fontWeight: Fonts.GeneralSmallHeaderFont.fontWeight,
    fontSize: Fonts.GeneralSmallHeaderFont.fontSize,
  },
};

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div
    className="btn p-0 d-flex align-items-center"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    ref={ref}
  >
    <div className="px-3" style={{ textAlign: "start" }}>
      {children}
    </div>
    <div
      className="p-3"
      style={{ borderInlineStart: "1px solid #F3F6F9", height: "100%" }}
    >
      &#x25bc;
    </div>
  </div>
));

const MenuHeader = () => {
  const history = useHistory();
  const user = getLocalStorageItem("accountInfo", true);

  return (
    <Dropdown className="dropdown-header">
      <Dropdown.Toggle variant="outline" as={CustomToggle}>
        <div className="d-flex">
          <div
            style={{
              ...styles.imgBody,
            }}
          >
            {user?.profileImage ? (
              <img
                src={user?.profileImage}
                style={{
                  ...styles.imgBody,
                }}
                alt="profile"
              />
            ) : (
              <div
                style={{
                  ...styles.imgBody,
                  backgroundColor: "#4A90E2",
                  color: FontColors.White,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: Fonts.GeneralSmallHeaderFont.fontWeight,
                  fontSize: Fonts.GeneralSmallHeaderFont.fontSize,
                  textTransform: "uppercase",
                }}
              >
                {`${user?.firstName?.[0] || ""}${user?.lastName?.[0] || ""}`}
              </div>
            )}
          </div>
          <div className="pr-5 align-self-center">
            <div>
              <Text
                className="text-start"
                style={{ ...styles.nameProfileText }}
              >
                {user?.firstName} {user?.lastName}
              </Text>
            </div>
            <div style={{ ...styles.userNameContainer }}>
              <Text style={{ ...styles.userNameProfileText }}>
                {user?.primary_email_address}
              </Text>
            </div>
          </div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu">
        <Dropdown.Item
          onClick={() => {
            history.push("/settings");
          }}
        >
          <UserSettingsComponent style={{ marginRight: 15 }} />
          Settings
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item
          onClick={() => {
            localStorage.removeItem("token");
            localStorage.removeItem("hasPayment");
            localStorage.removeItem("userAuthData");
            // history.push("/login");
            window.location.reload();
          }}
        >
          <LogOutSvg style={{ marginRight: 15 }} /> Logout
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
export const Header = ({ style, ...rest }) => {
  const isAuthenticated = getAuthenticated();
  const dispatch = useDispatch();
  const history = useHistory();
  const localLogoImage = localStorage.getItem("logoImg");
  const { logoImage } = useSelector((state) => state.organization);
  const location = useLocation();
  const handelTogggleDrawer = () => {
    dispatch(toggleDrawer({ type: "left" }));
  };

  if (
    !isAuthenticated ||
    (!location.pathname.includes(screens.HOME) &&
      !location.pathname.includes(screens.ADD_NEW_MEMBER) &&
      !location.pathname.includes(screens.YAHRZEIT) &&
      !location.pathname.includes(screens.ADD_NEW_YAHRZEIT) &&
      !location.pathname.includes(screens.FINANCE) &&
      !location.pathname.includes(screens.EVENTS) &&
      !location.pathname.includes(screens.DONATION) &&
      !location.pathname.includes(screens.DIRECTORY) &&
      !location.pathname.includes(screens.SCHOOLS) &&
      !location.pathname.includes(screens.HELP) &&
      !location.pathname.includes(screens.FAMILYMEMBERSTAB) &&
      !location.pathname.includes(screens.SETTINGS) &&
      !location.pathname.includes(screens.CLASSES))
  )
    return null;

  return (
    <header className="position-sticky top-0" style={{ zIndex: 101 }}>
      <nav
        className="navbar navbar-expand-lg navbar-light px-sm-4 px-xs-1 py-sm-2 bg-white"
        style={{ ...style, ...styles.body }}
        {...rest}
      >
        <div className="row d-flex align-items-center m-0 w-100">
          <div
            className="d-flex align-items-center d-block d-sm-none"
            style={{ zIndex: 999 }}
          >
            <button
              onClick={handelTogggleDrawer}
              className="btn p-0 burger-icon burger-icon-left"
              id="kt_aside_mobile_toggle"
            >
              <span />
            </button>
          </div>
          <div
            className="d-none d-sm-block"
            style={{ marginInlineStart: 15, marginInlineEnd: 80 }}
          >
            <Image
              src={logoImage !== undefined ? logoImage : localLogoImage || ""}
              style={{ width: 130, height: 50, cursor: "pointer" }}
              onClick={() => history.push("home")}
            />
          </div>
          <div className=" dropdown-container">
            <MenuHeader />
          </div>
        </div>
      </nav>
    </header>
  );
};
